<template>
  <div>
    <section :style="{ backgroundImage: 'url(' + require('@/assets/background_azul.png') + ')' }">
      <div class="container">
        <div class="row pt-4 pb-4">
          <div class="col-md-12">
            <img :src="require('@/assets/banner1.png')" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <p>El objetivo de esta conferencia es que, a través de una fuente oficial y reconocida por ICC, los asistentes aprendan de este tema con un fuerta énfasis local e internacional, así como de las nuevas reglas y las diferencias sobre las versiones anteriores</p>
            <p>Los asistentes tendrán la oportunidad de resolver dudas, entender la aplicación comercial a la compra venta internacional y obtener una visión más completa, real y objetiva del aprendizaje correcto de los Incoterms 2020</p>
          </div>
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              style="background-color: #0033a0 !important; color: #fff; font-weight: bold; border: 0;"
              @click="$router.push({name: 'eventoes'})"
            >INGRESO AL EVENTO</button>
            <br>
            <h5 class="text-center">Fecha 10 de octubre 8 AM . Hora Colombia.</h5>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row mt-4">
          <div class="col-md-6">
            <img :src="require('@/assets/icono1.png')" class="img-fluid" style="height: 80px;" />
            <h2 class="blue-heading mt-3">DIRIGIDO A</h2>
            <p>Empresarios; gerentes comerciales, financieros, logísticos, de compras; directores de comercio exterior; exportadores e importadores; asesores en comercio y negocios internacionales; funcionarios de entidades públicas y privadas; y demás profesionales de áreas que deban actualizarse en los usos y costumbres referentes a la entrega de mercaderías con los lncoterms® 2020.</p>
            <h2 class="blue-heading mt-3">DURACIÓN</h2>
            <p>4 horas</p>
          </div>
          <div class="col-md-6">
            <img :src="require('@/assets/icono2.png')" class="img-fluid" style="height: 80px;" />
            <h2 class="blue-heading mt-3">METODOLOGÍA</h2>
            <p>La metodología está orientada al logro de los objetivos enunciados y está conformada por:</p>
            <p>
              <span class="blue-text">Fundamentación teórica:</span> se imparte los fundamentales a través de una metodología llamada "Inner structure" que permite navegar por las obligaciones A1-A10, B1-B10.
            </p>
            <p>
              <span class="blue-text">Participación:</span> de los asistentes a través del comentario crítico y la discusión de sus propias experiencias, relacionadas con los tópicos tratados es incentivada a lo largo del curso.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <h2 class="blue-heading mt-3 mb-0 text-right">OBJETIVOS</h2>
            <h2 class="blue-heading mt-0 text-right">GENERALES</h2>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Conocer los nuevos términos.</li>
              <li>Aprender la estructura de reglas A1-A10, B1-B10 y hacer uso eficiente del texto oficial.</li>
              <li>Comprender las reglas Incoterms® 2020, y las obligaciones de las partes (Clausulados A y B).</li>
            </ul>
          </div>
        </div>
        <hr style="background-color: #00b4e5; height: 5px;" />
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <h2 class="blue-heading mt-3 mb-0 text-right">OBJETIVOS</h2>
            <h2 class="blue-heading mt-0 text-right">ESPECÍFICOS</h2>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Establecer una visión general de Incoterms® 2020.</li>
              <li>Comprender las reglas Incoterms® 2020 en el contexto histórico y actual.</li>
              <li>Distinguir los cambios sobre las diferentes versiones.</li>
              <li>Aprender a conciliar las necesidades de cada rol (comprador - vendedor) con las reglas Incoterms® 2020.</li>
              <li>Aplicar contratos de compraventa.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="container">

        <div class="row mt-4">
          <div class="col-md-6">
            <ul class="text-center" style="list-style: none; float: right;">
              <li style="display: inline-block;">
                <img :src="require('@/assets/icono3.png')" class="img-fluid" style="height: 80px;" />
              </li>
              <li style="display: inline-block;">
                <h2 class="blue-heading pl-3">CONTENIDO</h2>
              </li>
            </ul>
          </div>

       <div class="col-md-6 ">
              <ol>
                <li>La ICC como organización generadora de instrumentos de comercio e Incoterms®</li>
                <li>Historia de Incoterms®</li>
                <li>Incoterms® para usuarios. Lo que todo empresario debe saber. Borrando mitos</li>
                <li>Errores frecuentes en el uso de Incoterms®</li>
                <li>Cambios oficiales en Incoterms® 2020</li>
                <li>Notas orientativas Incoterms® 2020</li>
                <li>Incoterms(2010) e Incoterms(2020). Transición desde las obligaciones A1-A10, B1-B10</li>
                <li>El seguro y las ventas repetitivas ”String Sales” en Incoterms® 2020</li>
              </ol>
            </div>
        </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-5">
            <img :src="require('@/assets/expositor.png')" class="img-fluid" style="height: 550px;" />
            <h2 class="blue-heading mt-3 mb-0">JUAN DIEGO</h2>
            <h2 class="blue-heading">ALZATE GÓMEZ</h2>
          </div>
          <div class="col-md-7">
            <p>Miembro de las comisiones de Derecho y Prácticas Mercantiles y Aduanas y Facilitación del Comercio de ICC Colombia, así como coordinador y formador del “Train The Trainer” para International Chamber of Commerce - Comité Nacional Colombia y colaborador de varios comités en Latinoamérica. Fue Accredited Trainer en Incoterms®2010 de ICC.</p>
            <p>Experto en Negocios Internacionales, Supply Chain Management (SCMC®). Conferencista y entrenador en asuntos Comerciales Internacionales, Mercadeo Internacional, Planeación estratégica. Catedrático de posgrados, en diferentes países de Latinoamérica y miembro de varias juntas directivas. Conferencista Internacional, Director General de Megatransport Projects Logistics.</p>
            <p>En el año 2011 fundó la firma Maximum Consulting dedicada al Derecho Internacional de los Negocios, Estrategia y Supply Chain.</p>
            <p>Actualmente es candidato a doctor en “Business Administration” por Maastricht School of Management, The Netherlands y Phd en “Administración Estratégica” de CENTRUM Graduate Business School. Es “MBA” por EADA Business School de España y es “Magister en Negocios Globales” por la Universidad Católica del Perú. Master on Philosophy por Maastritch School of Management y ”Especialista en Gerencia de Mercadeo” por la Universidad Externado de Colombia.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "infopt",
  data() {
    return {};
  }
};
</script>
<style scoped>
.blue-text,
.blue-heading {
  color: #0033a0;
  font-weight: bold;
}

p {
  color: #000;
  font-family: "Open Sans", sans-serif;
}

label {
  color: #fff;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
}

.text-danger {
  text-shadow: 1px 1px #000;
}

.barco {
  border: 20px solid #fff;
  -webkit-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
}

#sura-logo {
  height: 80px;
}

#logo {
  height: 80px;
  display: block;
  margin: 0 auto;
}
</style>
